import { useCallback } from 'react';

import { CurrentProviderEzwmConfigurationQuery } from '@dreryk/egabinet-ezwm-frontend-api';

import { refetchCqrsQuery } from '@dreryk/command-query-react-common';
import { useFormController } from '@dreryk/react-common';
import { FormRouteLeavingPrompt, StyledFlex } from '@dreryk/react-components';

import { EzwmSenderCodeFormBean } from './EzwmSenderCode.types';
import { EzwmSenderCodeInfoNotification } from './EzwmSenderCodeInfoNotification';
import { EzwmSenderCodeInput } from './EzwmSenderCodeInput';
import { EzwmSenderCodeRemove } from './EzwmSenderCodeRemove/EzwmSenderCodeRemove';
import { EzwmSenderCodeSaveButton } from './EzwmSenderCodeSaveButton';

type EzwmSenderCodeFormProps = {
   readonly senderCode: string | null;
};

export const EzwmSenderCodeForm = (props: EzwmSenderCodeFormProps): JSX.Element => {
   const { register, handleSubmit, reset, formState } = useFormController<EzwmSenderCodeFormBean>({
      senderCode: props.senderCode ?? '',
   });
   const handleCodeRemoveSuccess = useCallback(() => {
      reset({ senderCode: '' });
      refetchCqrsQuery(CurrentProviderEzwmConfigurationQuery);
   }, [reset]);
   return (
      <>
         <StyledFlex direction={'column'} gap={'8px'} as={'form'} noValidate>
            <EzwmSenderCodeInput register={register} />
            <EzwmSenderCodeInfoNotification />
            <StyledFlex gap={'12px'}>
               <EzwmSenderCodeSaveButton handleSubmit={handleSubmit} />
               {props.senderCode ? <EzwmSenderCodeRemove onRemoveSuccess={handleCodeRemoveSuccess} /> : null}
            </StyledFlex>
         </StyledFlex>
         <FormRouteLeavingPrompt formState={formState} />
      </>
   );
};
